import { type Location } from '../domain/Location'
import { type Option } from '../domain/Option'

export function formatLocationToOption(
  location: Location,
  showDefaultLabel = true
): Option<Location> {
  return {
    value: location,
    label: location.address ? location.address : showDefaultLabel ? 'No address provided' : '', // This is a fallback in case the address is not provided
  }
}
